import { Content } from "antd/lib/layout/layout";

import bgImage from '../../images/bg-img.png'
import CandidateView2 from "../../components/proyect2/candidate/CandidateView2";



const CandidateScreen = () => {
  return (
    <Content style={{ height: "100vh", width: "100vw", minWidth:1200}} >
      <div>
        <img style={{width:"100vw", height:"100vh", position:'absolute', backgroundColor:"red", zIndex:0, minWidth:1350}} src={bgImage} alt={bgImage} />
      </div>
      <div style={{height:'100%', width: "100%", minWidth:1200}}>
          <CandidateView2 />
      </div>
    </Content>
  )
}

export default CandidateScreen